//#region Styles
import {
	Part,
	Row,
	Column,
	TitleSection,
	TitleSection2,
	ResumeSection,
} from "components/styles";
import { EventGraphicImg } from "../../styles";
//#endregion
//#region Components
import CustomButton from "components/CustomButton/CustomButton";
import DataField from "views/components/Detail/DataField/DataField";
import DurationDataFields from "views/components/Detail/DurationDataFields/DurationDataFields";
//#endregion
//#region Icons
import PenIcon from "icons/PenIcon";
import { useEffect, useState } from "react";
import ModalTraspaso from "../ModalTraspaso/ModalTraspaso";
import useStudentTransfer from "views/Eventos/components/EventListView/ListComponent/utils/hooks/useStudentTransfer";
import useLoadingRequest from "components/Preloader/utils/hooks/useLoadingRequest";
import { requestGetProfessionalTools } from "services/events/aboutEvents";
//#endregion

const ResumeStep1 = ({
	data,
	eventTypes,
	eventSubtypes,
	eventGraphics,
	complementaryServiceAreas,
	allDays,
	toStep,
	cannotUpdate,
	extracurricularSections,
}) => {
	//#region Effects
	//#endregion
	//#region Functions

	
	const studentsEnrolled = useStudentTransfer();
	const loadingRequest = useLoadingRequest();

	const [active, setActive] = useState(false);
	const [dataEstudents, setDataEstudents] = useState([]);
	const [events, setEvents] = useState([]);

	const getDataPart1 = () => {
		const {
			title,
			description,
			standOutEvent,
			eventTypeId,
			eventSubtypeId,
			eventGraphicId,
			complementaryServiceAreaId,
			linkInformacion,
			linkInformacionDesc,
			sectionSubtype
		} = data;
		// idAreaServicioPorTipoEvento
		const complementaryServiceAreaName =
			complementaryServiceAreas.find(
				({ id }) => id === complementaryServiceAreaId
			)?.name || "-";
		const dataPart = [
			[
				{ field: "Título", description: title },
				{ field: "Descripción", description },
				{
					field: "¿Es destacado?",
					description: standOutEvent ? "Sí" : "No",
				},
				{ field: "Link de más información", description: linkInformacionDesc },
				{ field: "Enlace", description: linkInformacion },
			],
			[],
			[
				{
					field: "Área de servicio complementario:",
					description: complementaryServiceAreaName,
				},
			],
		];
		const eventTypeName = eventTypes.find(
			({ id }) => id === eventTypeId
		).name;
		const eventGraphicImage = eventGraphics.find(
			({ id }) => id === eventGraphicId
		).image;
		
		dataPart[1] = [
			{
				field: "Tipo de evento:",
				description: eventTypeName,
			},
			{
				field: "Gráfica de evento:",
				render: <EventGraphicImg src={eventGraphicImage} />,
			},
		];
		if (eventSubtypeId > 0) {
			const eventSubtypeName = eventSubtypes.find(
				({ id }) => id === eventSubtypeId
			).name;
			dataPart[1].splice(1, 0, {
				field: "Subtipo de evento:",
				description: eventSubtypeName,
			});
		}
		if (sectionSubtype){
			const sectionSubtypeObj =
			extracurricularSections.find(
				({ courseCode }) => courseCode === sectionSubtype
			);
			dataPart[2].push({
				field: "Sección extracurricular:",
				description: `${sectionSubtypeObj.classNumber} - ${sectionSubtypeObj.courseName}`,
			})
		}
		return dataPart;
	};

	useEffect(() => {
		if(studentsEnrolled.value){
			setDataEstudents(studentsEnrolled.value)
		}
	}, [studentsEnrolled.value])
	const handlerActive = async() => {
		loadingRequest.show();
		
		await studentsEnrolled.fetchStudentsEnrolled(data);
		const response = await requestGetProfessionalTools();
		setEvents(response);
		setActive(true);
		loadingRequest.hide();
	}

	const handleClose = () => {
		setActive(false);
	}
	//#endregion
	return (
		<>
			<Part>
				<Row>
					<Column width="max-content">
						<TitleSection>Resumen:</TitleSection>
						<TitleSection2>Detalles de evento</TitleSection2>
					</Column>
					{!cannotUpdate && (
						<div>
							<CustomButton
								variant="quintinary"
								text="Editar sección"
								icon={<PenIcon />}
								onClick={toStep}
							/>
							{
								data.seccionExtracurricularId > 0 &&
								<div style={{ marginTop: "10px" }}>
									<CustomButton
										variant="quintinary"
										text="Traspaso"
										icon={<PenIcon />}
										onClick={handlerActive}
										disabled={data.estadoTraslado}
									/>
								</div>
							}
							
						</div>
					)}
				</Row>
				<ResumeSection>
					{data && (
						<>
							<Part direction="row">
								{getDataPart1().map((row, idx1) => {
									const widths = ["45%", "25%", "25%"];
									return (
										<Column
											key={idx1}
											width={widths[idx1]}
											gap="20px"
										>
											{row.map((item, idx2) => {
												return (
													<DataField
														key={idx2}
														{...item}
													/>
												);
											})}
										</Column>
									);
								})}
							</Part>
							<Part gap="25px">
								<DurationDataFields
									allDays={allDays}
									duration={data.duration}
								/>
							</Part>
						</>
					)}
				</ResumeSection>
			</Part>
			{
				active && <ModalTraspaso 
					active
					handleClose={handleClose}
					data={dataEstudents}
					events={events}
					eventDetail={data}
				/>
			}
			
		</>
	);
};

export default ResumeStep1;
